// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2nQgX","inputWrap":"Table_inputWrap__37_9S","col":"Table_col__1L98s","bmiTooltip":"Table_bmiTooltip__1I121"};